import { createFileRoute } from '@tanstack/react-router'
import { Outlet } from '@tanstack/react-router'
import { Main } from '@/components/layout/main'
import { UnifiedHeader } from '@/components/layout/unified-header'

export const Route = createFileRoute('/_authenticated/fns-responses')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <>
      <UnifiedHeader />
      <Main>
        <Outlet />
      </Main>
    </>
  )
}
